<template>
  <div class="view pa24">
    <p class="cA2 mb10">
      <b>{{ $t('miniprogram', 'enterpriseWeChatAuthProcess') }}</b><br />
      {{ $t('miniprogram', 'enterpriseWeChatAuthStep1') }}<br />
      {{ $t('miniprogram', 'enterpriseWeChatAuthStep2') }}<br />
      {{ $t('miniprogram', 'enterpriseWeChatAuthStep3') }}
    </p>
    <div v-if="accountId">
      <table class="align-cen-table textc table table-hover table-bordered bgf6f9fa fixed-table text-ellipsis">
        <thead>
        <tr>
          <th>{{ $t('miniprogram', 'configName') }}</th>
          <th>{{ $t('miniprogram', 'enterpriseId') }}</th>
          <th width="400">{{ $t('miniprogram', 'appSecret') }}</th>
          <th>{{ $t('miniprogram', 'authStatus') }}</th>
          <th>{{ $t('miniprogram', 'createTime') }}</th>
        </tr>
        </thead>
        <tbody class="bgfff">
        <tr>
          <td>{{ruleForm.appName}}</td>
          <td>{{ruleForm.appId}}</td>
          <td>{{ruleForm.appSecret}}</td>
          <td>{{isQywxAuth ? $t('miniprogram', 'authorized') : $t('miniprogram', 'notAuthorized') }}</td>
          <td>{{ruleForm.createTime | getDataTimeSec('yyyy-MM-dd hh:mm:ss') }}</td>
        </tr>
        </tbody>
        
      </table>
      <el-button type="primary" v-if="userInfo.roleId && qywxSwitch" @click="toWeChat"><span v-if="isQywxAuth">{{ $t('miniprogram', 'reauthorize') }}</span>{{ $t('miniprogram', 'authorization') }}</el-button>
      <el-button type="primary" @click="resetQywx">{{ $t('miniprogram', 'resetConfig') }}</el-button>
    </div>
    <el-form
      v-else
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="top"
      class="demo-ruleForm"
    >
      <el-form-item :label="$t('miniprogram', 'configName')" prop="appName">
        <el-col :lg="11">
          <el-input
            :placeholder="$t('miniprogram', 'pleaseEnterConfigName')"
            v-model="ruleForm.appName"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'enterpriseId')" prop="appId">
        <el-col :lg="11">
          <el-input
            type="text"
            :placeholder="$t('miniprogram', 'pleaseEnterEnterpriseId')"
            v-model="ruleForm.appId"
          ></el-input>
          <p>
            {{ $t('miniprogram', 'configNameDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'appSecret')" prop="appSecret">
        <el-col :lg="11">
          <el-input
            type="text"
            :placeholder="$t('miniprogram', 'pleaseEnterAppSecret')"
            v-model="ruleForm.appSecret"
            maxlength="50"
          ></el-input>
          <p>
            {{ $t('miniprogram', 'appSecretDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :lg="11">
          <el-button type="primary" @click="submitQywx">{{ $t('miniprogram', 'save') }}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <el-dialog :title="$t('miniprogram', 'resetEnterpriseWeChatInfo')" 
               width="30%"
               :center="true"
               :modal-append-to-body="false"
               :visible="dialogTableVisible"
               @close="dialogClose">
        <p class="fs8 text-align cA1">
          {{ $t('miniprogram', 'resetEnterpriseWeChatDesc') }}
        </p>
        <div class="mt40 flex-c-c ">
          <el-button type="primary" plain @click="dialogClose">
            {{ $t('miniprogram', 'cancel') }}
          </el-button>
          <el-button type="primary" @click="onConfirmReset">
            {{ $t('miniprogram', 'confirm') }}
          </el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import {getCompanyAccountList, componentloginpage, unbindCompanyAccount} from "@/api/authorization"
import { Message } from 'element-ui'
import { getDataTimeSec } from "@/utils";
import { authUrl, callback, qywxSetting } from "@/api/qywx.js";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  props:{
    accountMap: {
      default: ''
    }
  },
  data() {
    return {
      accountId: 0,
      dialogTableVisible: false,
      ruleForm: {},
      ruleForm_: {
        appName: this.$t('miniprogram', 'enterpriseWeChat'),
        appId: "",
        appSecret: "",
      },
      rules: {
        appName: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterConfigName'), trigger: "blur" },
        ],
        appId: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterEnterpriseId'), trigger: "blur" },
        ],
        appSecret: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterAppSecret'), trigger: "blur" },
        ],
      },
      idMap:{
        1: 'userApp',
        2: 'crmApp',
        3: 'pcData',
        4: 'payInfo',
        8: 'qywx',
      },
      userInfo: this.$store.state.loginRoot.userInfo,
      authUrlImg: "",
      qywxSwitch: 0,
      isQywxAuth: 0,
      authCode: ''
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created(){
    this.accountId = this.accountMap.accountId
    this.ruleForm = this.accountMap
    if(!this.accountId) {
      this.ruleForm = this.ruleForm_
    }
    console.log('ruleForm:', this.ruleForm)
    this.authCode = this.$route.query.auth_code
    if(this.authCode) {
      this.WeChatCallback()
    }
    this.qywxSetting()
  },
  computed:{
    checkAppSecret(){
     return  this.ruleForm.AppSecret ? '' : 'password'
    }
  },
  methods:{
    async submitQywx(){
      if(!this.ruleForm.appName){
        return this.$message.error(this.$t('miniprogram', 'pleaseEnterConfigName'))
      }
      if(!this.ruleForm.appId){
        return this.$message.error(this.$t('miniprogram', 'pleaseEnterEnterpriseId'))
      }
      if(!this.ruleForm.appSecret){
        return this.$message.error(this.$t('miniprogram', 'pleaseEnterAppSecret'))
      }
      let data = {
        appName: this.ruleForm.appName,
        appId: this.ruleForm.appId,
        appSecret: this.ruleForm.appSecret,
        accountType: 8
      }
      const result =  await componentloginpage(data)
      console.log(result)
      if(result.code == 200){
        Message({message: this.$t('miniprogram', 'submitSuccess'),type:'success'})
        this.getAppInfo()
      }else{
        Message({message: this.$t('miniprogram', 'submitFailed'),type:'error'})
      }
    },
    async getAppInfo(){
      const result =  await getCompanyAccountList({appid:true})
      console.log(result)
      if(result.data){
        let tmp = {};
        result && result.data.map(val => {
          tmp[val.accountType] = val;
          if(val.accountType == 8){
              this.accountId = val.accountId
              this.ruleForm = val
          }
        });
        this.accountMap = tmp;
        console.log(this.accountMap) 
      }
    },
    dialogClose(){
      this.dialogTableVisible = false
    },
    resetQywx(){
      this.dialogTableVisible = true
    },
    async onConfirmReset(){
      let data = {
        accountId:this.accountId
      }
      const result =  await unbindCompanyAccount(data)
      console.log(result)
      if(result.code == 200){
        this.$message.success(this.$t('miniprogram', 'resetSuccess'))
        this.dialogTableVisible = false
        this.accountId = 0
        this.ruleForm = this.ruleForm_
      }else{
        this.$message.error(this.$t('miniprogram', 'resetFailed'))
      }
    },
    authUrl(){
      authUrl({ignore:true})
      .then(res=>{
        console.log(res)
        this.authUrlImg = res.data
      })
      .catch(err=>{
        console.log(err)
      })
    },
    qywxSetting(){
      qywxSetting({ignore:true})
      .then(res=>{
        console.log(res)
        if (res.success && res.code == 200 && res.data) {
          this.qywxSwitch = res.data.qywxSwitch
          this.isQywxAuth = res.data.isQywxAuth
          // this.qywxSwitch && !this.isQywxAuth && this.authUrl()
        }
      })
      .catch(err=>{
        console.log(err)
      })
    },
    WeChatCallback(){
      var that = this
      let data = {
        auth_code:this.$route.query.auth_code,
        state:this.$route.query.state,
        expires_in:this.$route.query.expires_in
      }
      console.log('WeChatCallback', data)
      if(!data.auth_code || !data.state || !data.expires_in) {
        return
      }
      callback(data)
      .then(res=>{
        console.log(res)
        if (res.code == 200) {
          this.$message.success({
            message: this.$t('miniprogram', 'authorizationSuccess'),
            onClose: function() {
              that.$router.push('/appletConfig?activeName=qywx')
              that.qywxSetting()
            }
          })
        } else {
          this.$message.error(this.$t('miniprogram', 'authorizationFailed'))
        }
      })
      .catch(err=>{
          this.$message.error(this.$t('miniprogram', 'authorizationFailed'))
      })
    },
    toWeChat(){
      authUrl({ignore:true})
      .then(res=>{
        console.log(res)
        if (res.code == 200) {
          this.authUrlImg = res.data
          if(!this.authUrlImg) {
            this.$message.error(this.$t('miniprogram', 'authUrlFailed'))
            return
          }
          window.location.href = this.authUrlImg
        } else {
          this.$message.error(this.$t('miniprogram', 'authUrlFailed'))
        }
      })
      .catch(err=>{
        console.log(err)
        this.$message.error(this.$t('miniprogram', 'authUrlFailed'))
      })
    },
  }
};
</script>

<style lang="scss" scoped>
table th{
  background: #F7FAFA;
}
tbody:hover{
  background: #F7FAFA;
}
table tr{
  height: 50px;
}
.text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fixed-table {
    table-layout: fixed;
}

.textc {
    text-align: center;
}
.bgf6f9fa {
    background: #F6F9FA;
}
.table-bordered {
    border: 1px solid #dee2e6;
}
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}
body * {
    font-family: "Microsoft YaHei UI";
}
table {
    border-collapse: collapse;
}
* {
    outline: none;
}
*, ::after, ::before {
    box-sizing: border-box;
}
</style>
